import fetch from "@/fetch";

// 获取CSH列表数据
export const getCshlist = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/todaysnapshot/select_csh",
    data: params
  });
};

// 获取Header部数据（交易金额/订单金额/用户数量）
export const getHeaderData = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/todaysnapshot/ordersummary",
    data: params
  });
};

//订单查询结果
export const getOrderList = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/todaysnapshot/searchorder",
    data: params
  });
};
